module.exports = __webpack_public_path__ + "static/media/rising-pops.b0480a50.mp3";